<template>
  <b-container fluid>
    <b-row class="mb-3"
           align-v="center"
           align-h="around"
           cols-xl="2"
           cols="1">
      <template v-for="(item, index) in contents">
        <b-col v-if="item.type === 'image'"
               class="column"
               :key="item.type + index">
          <img :src="item.imageUrl"
               alt="chart"/>
        </b-col>
        <b-col v-else-if="item.type === 'json' && item.content.length > 0"
               class="column"
               :key="item.type + index">
          <survey-table :slide="slide"
                        :items="item.content"/>
        </b-col>
      </template>
    </b-row>
  </b-container>
</template>

<script>
import SurveyTable from "@/components/survey/SurveyTable.vue";

export default {
  components: { SurveyTable },
  props: ['slide'],
  computed: {
    contents() {
      return this.slide.content;
    }
  }
}
</script>

<style scoped>
img {
    width: 100%;
}
</style>